import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Autoplay,
  // FreeMode,
  Pagination,
  Navigation,
  EffectCoverflow,
} from 'swiper/modules';
// import CustomModal from './CustomModal';
import portfolioData from '../data/data';

import 'swiper/css/pagination';
import 'react-tooltip/dist/react-tooltip.css';
import 'swiper/css/effect-coverflow';
import '../assets/style/customSwiperThree.scss';

const Portfolio = () => {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null); // Track expanded item
  // const [slidesPerView, setSlidesPerView] = useState('auto');

  const handleAnchorClick = (e) => {
    // This stops the event from bubbling up to the parent div
    e.stopPropagation();
  };

  // const closeModal = () => {
  //   setIsModalOpen(false);
  //   // setTimeout(() => {
  //   // }, 1000);
  // };

  const toggleCardExpansion = (cardId) => {
    if (expandedItem === cardId) {
      // If the clicked card is already expanded, close it
      setExpandedItem(null);
    } else {
      // If it's a different card, expand it and close the previously expanded card
      setExpandedItem(cardId);
    }
  };

  const handleSlideChange = () => {
    // Close the expanded card when the swiper slide changes
    if (expandedItem !== null) {
      setExpandedItem(null);
    }
  };

  // Define a wrapper component for CustomModal with memoization
  // const CustomModalWrapper = React.memo(
  //   ({ isModalOpen, closeModal, portfolioItem }) => (
  //     // Compare the portfolioItem prop to determine whether the component should update

  //     isModalOpen ? (
  //       <CustomModal
  //         isOpen={isModalOpen}
  //         closeModal={closeModal}
  //         portfolioItem={portfolioItem}
  //       />
  //     ) : null), (prevProps, nextProps) => prevProps.portfolioItem === nextProps.portfolioItem,
  // );

  // CustomModalWrapper.displayName = 'CustomModalWrapper';

  // CustomModalWrapper.propTypes = {
  //   isModalOpen: PropTypes.bool.isRequired,
  //   closeModal: PropTypes.func.isRequired,
  //   portfolioItem: PropTypes.shape({}).isRequired,
  // };

  /*   const CustomModalWrapper = React.memo(({ isModalOpen,
    closeModal, portfolioItem }) => (isModalOpen ? <CustomModal isOpen={isModalOpen}
       closeModal={closeModal} portfolioItem={portfolioItem} /> : null), (prevProps, nextProps) =>
      // Compare the portfolioItem prop to determine whether the component should update
      prevProps.portfolioItem === nextProps.portfolioItem); */

  // 309 css pregledaj backround overlay
  // useEffect(() => {
  //   const handleResize = () => {
  //     const width = window.innerWidth;
  //     if (width < 425) {
  //       setSlidesPerView(1);
  //     } else {
  //       setSlidesPerView('auto');
  //     }
  //   };

  //   handleResize();

  //   window.addEventListener('resize', handleResize);

  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  return (
    <div className="my-portfolio-wrapper">
      <h1>
        {/* <span className="h1-top-line" /> */}
        <span className="h1-top-dot" />
        Portfolio
      </h1>

      <Swiper
        wrapperClass="mySwiperThree-wrapper"
        pagination={{
          clickable: true,
          el: '.swiper-pagination3',
          type: 'progressbar',
        }}
        navigation
        modules={[Autoplay, Pagination, Navigation, EffectCoverflow]}
        slidesPerView="auto"
        spaceBetween={30}
        // freeMode
        className="mySwiperThree"
        effect="coverflow"
        grabCursor
        centeredSlides
        // slidesPerView="auto"
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        }}
        allowTouchMove
        onSlideChange={handleSlideChange}
      // onTouchStart={handleSwipeStart}
      >
        {portfolioData.map((portfolioItem) => (
          <SwiperSlide key={portfolioItem.id}>
            <div
              className={`project-card ${expandedItem === portfolioItem.id ? 'expanded' : ''}`}
              style={{
                backgroundImage: `url(${portfolioItem.src})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: `${portfolioItem.position}`,
              }}
              onClick={() => { toggleCardExpansion(portfolioItem.id); }}
              role="presentation"
            >
              <span
                style={{
                  position: 'absolute',
                  right: '0',
                  zIndex: '4',
                  padding: '5px',
                  // background: '#860000d1',
                  background: '#c01d1dd1',
                  fontSize: '15px',
                  fontFamily: 'Atkinson',
                  color: '#fff',
                }}
              >
                {portfolioItem.date}
              </span>
              <h2 style={{
                pointerEvents: 'none',
                position: 'relative',
                margin: '0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                zIndex: '4',
                color: 'transparent',
                backgroundClip: 'text',
                fontSize: '4rem',
                breakWord: 'break-word',
                backgroundImage: 'linear-gradient(45deg, #3c4048, #fefefe)',
              }}
              >
                {portfolioItem.title}
              </h2>

              <a
                href={`${portfolioItem.live_demo}`}
                target="_blank"
                rel="noreferrer"
                className="a-button button-arrow bg-blue"
                onClick={handleAnchorClick}
                style={{
                  position: 'absolute',
                  left: '0',
                  right: '0',
                  zIndex: '2',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  bottom: '20px',
                  maxWidth: '200px',
                  margin: '0 auto',
                }}
              >
                Visit on GitHub
                <svg viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow-icon">
                  <g className="arrow-head">
                    <path d="M1 1C4.5 4 5 4.38484 5 4.5C5 4.61516 4.5 5 1 8" stroke="currentColor" strokeWidth="2" />
                  </g>
                  <g className="arrow-body">
                    <path d="M3.5 4.5H0" stroke="currentColor" strokeWidth="2" />
                  </g>
                </svg>
              </a>

              <div className="project-card__overlay">
                <div className="project-card__cover">
                  <h2 className="project-card__title">{portfolioItem.id}</h2>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* <CustomModal isOpen={isModalOpen} closeModal={closeModal}
       portfolioItem={selectedItem} /> */}

      {/* <CustomModalWrapper
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        portfolioItem={selectedItem}
      /> */}

      <div className="swiper-pagination3" />
      <Tooltip className="react-tooltip" id="important-read-live" />
      <Tooltip className="react-tooltip" id="important-read-git" />
    </div>
  );
};

export default Portfolio;
